import { render } from "./WalletConfigurationPage.vue?vue&type=template&id=955c4976"
import script from "./WalletConfigurationPage.vue?vue&type=script&lang=js"
export * from "./WalletConfigurationPage.vue?vue&type=script&lang=js"

import "./WalletConfigurationPage.vue?vue&type=style&index=0&id=955c4976&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__